module.exports = __webpack_public_path__ + "waiting-for-octopus.0137c8c191c0d742d698fd4be3309d02.hashedasset.svg";